import DocPage from '../components/DocPage.jsx'
import { docsMusic } from '../content.js'

// /docs/music — P6-206. The fifth feature page, and the last of P6-104's slots
// to be filled.
//
// 🔴 IT WAS NOT UNWRITTEN FOR WANT OF AN AUTHOR, and that is the only
// interesting thing about this file. P6-105 wrote /docs/events and left this
// one deliberately empty: music is a separate deployable, its sixteen commands
// were in no catalog the site could check a name against, and a page naming
// /play would have reddened the very gate that exists to stop a member being
// sent after a command that answers with nothing. content-src/sections.json
// carries the full argument and what closed it.
//
// Four lines, like every sibling, because the page TYPE already existed — see
// DocsMovieNight.jsx for why that is the whole return on components/DocPage.jsx.
// The panel at src/portal/MusicPanel.jsx links here through `docSection` in
// src/portal/branches.js, which has pointed at this section since P6-186 and
// until now resolved to a slot.

export default function DocsMusic() {
  return <DocPage doc={docsMusic} />
}
